// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__yN01H","loader--stats":"Loader_loader--stats__KGISE"};